var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: currentColor;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23.58,1.83c-2.36-1.41-5.69-1.83-5.69-1.83l-.69,1.83c-1.39-.56-3.19-.42-3.19-.42,0,0-1.8-.14-3.19.42l-.69-1.83s-3.33.42-5.69,1.83C4.42,1.83-.85,7.47.12,18.47c0,0,3.19,2.4,6.94,3.53l1.67-2.54-2.36-1.13.42-.42s3.61,1.68,7.22,1.68,7.22-1.68,7.22-1.68l.42.42-2.36,1.13,1.67,2.54c3.75-1.13,6.94-3.53,6.94-3.53.97-11-4.3-16.64-4.3-16.64Zm-14.3,13.12c-1.46,0-2.64-1.2-2.64-2.68s1.18-2.68,2.64-2.68,2.64,1.2,2.64,2.68-1.18,2.68-2.64,2.68Zm9.44,0c-1.46,0-2.64-1.2-2.64-2.68s1.18-2.68,2.64-2.68,2.64,1.2,2.64,2.68-1.18,2.68-2.64,2.68Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordIcon);
export default __webpack_public_path__ + "static/media/discordIcon.edf855ef0d5d2a03ce6f4e3444f72daf.svg";
export { ForwardRef as ReactComponent };